<template>
  <a-card :bordered="false">
    <a-steps class="steps" :current="currentTab">
      <a-step title="填写充值金额"/>
      <a-step title="扫描二维码支付"/>
      <a-step title="完成"/>
    </a-steps>
    <div class="content">
      <step1 v-if="currentTab === 0" @nextStep="nextStep" @goBackList="goBackList"/>
      <step2
        v-if="currentTab === 1"
        @nextStep="nextStep"
        @prevStep="prevStep"
        @goBackList="goBackList"
      />
      <step3 v-if="currentTab === 2" @finish="finish" @goBackList="goBackList"/>
    </div>
  </a-card>
</template>

<script>
import Step1 from './SellerRecharge_component/Step1'
import Step2 from './SellerRecharge_component/Step2'
import Step3 from './SellerRecharge_component/Step3'

export default {
  components: {
    Step1,
    Step2,
    Step3
  },
  data() {
    return {
      money: 0,
      QRcodeID: '',
      currentTab: 0,
      // form
      form: null,
      dispercent: 1
    }
  },
  methods: {
    // handler
    nextStep(inputMoney, sellerDispercent, QRID) {
      if (inputMoney > -1) {
        this.money = inputMoney
        this.QRcodeID = QRID
      } else {
        this.money = 0
        this.QRcodeID = ''
      }
      if (sellerDispercent < 1) {
        this.dispercent = sellerDispercent
      }
      if (this.currentTab < 2) {
        this.currentTab += 1
      }
    },
    prevStep() {
      if (this.currentTab > 0) {
        this.currentTab -= 1
      }
    },
    finish() {
      this.currentTab = 0
    },
    goBackList() {
      this.$emit('onGoBack')
    }
  }
}
</script>

<style lang="less" scoped>
.steps {
  max-width: 750px;
  margin: 16px auto;
}
</style>
